import { border, borderRadius, colors, dimensions } from '@factorialco/deprecated-design-system'

export function overrideHapiElementsStyles() {
  const themeOverrides = {
    buttonBaseStyles: {
      borderStyle: border.style.solid,
      borderWidth: border.width.s2,
      borderRadius: borderRadius.abs008,
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      height: '40px',
      paddingBottom: dimensions.s4,
      paddingLeft: `${dimensions.s16} !important`,
      paddingRight: `${dimensions.s16} !important`,
      paddingTop: dimensions.s4,
      textTransform: 'none',
      width: 'fit-content',

      '&:disabled': {
        opacity: 0.5,
      },
    },
    inputBaseStyles: {
      borderRadius: borderRadius.abs008,
      borderColor: colors.grey400,
      borderWidth: border.width.s2,
    },
    global: {
      borderRadius: borderRadius.abs008,

      primaryBackgroundColor: colors.grey600,
      primaryTextColor: colors.grey800,

      secondaryBackgroundColor: colors.grey400,
      secondaryTextColor: colors.grey1000,

      successBackgroundColor: colors.lime1000,
      successTextColor: colors.grey000White,

      dangerBackgroundColor: colors.radicalRed800,
      dangerTextColor: colors.grey000White,

      warningTextColor: colors.grey000White,

      infoBackgroundColor: colors.viridian1200,
      infoTextColor: colors.grey000White,

      // Basket title text color
      accentBackgroundColor: colors.grey800,

      // Form label info
      warningBackgroundColor: colors.champagne400,

      // Form label description
      fadedTextColor: colors.grey800,

      // Basket Summary
      infoSecondaryBackgroundColor: colors.grey000White,
      infoSecondaryTextColor: colors.grey1000,

      successSecondaryBackgroundColor: colors.grey000White,
      successSecondaryTextColor: colors.grey800,
    },
    buttonBase: {
      extend: 'buttonBaseStyles',
      backgroundColor: colors.grey1000,
      borderColor: colors.grey1000,
      color: colors.grey000White,

      '&:hover:enabled, &:disabled': {
        backgroundColor: colors.grey800,
      },
    },
    buttonPrimary: {
      extend: 'buttonBaseStyles',
      backgroundColor: colors.grey1000,
      borderColor: colors.grey1000,
      color: colors.grey000White,

      '&:hover:enabled, &:disabled': {
        backgroundColor: colors.grey800,
      },
    },
    buttonSecondary: {
      extend: 'buttonBaseStyles',
      color: colors.grey800,
      backgroundColor: colors.lighter000,
      borderColor: colors.grey800,

      '&:hover:enabled, &:disabled': {
        borderColor: colors.grey1000,
        backgroundColor: colors.darker040,
      },
    },
    buttonDanger: {
      extend: 'buttonBaseStyles',

      color: colors.grey800,
      backgroundColor: colors.lighter000,
      borderColor: colors.grey800,

      '&:hover:enabled, &:disabled': {
        borderColor: colors.grey1000,
        backgroundColor: colors.darker040,
      },
    },
    buttonDangerSecondary: {
      extend: 'buttonBaseStyles',
      color: colors.grey800,
      backgroundColor: colors.lighter000,
      borderColor: colors.grey800,

      '&:hover:enabled, &:disabled': {
        borderColor: colors.grey1000,
        backgroundColor: colors.darker040,
      },
    },
    buttonInfo: {
      extend: 'buttonBaseStyles',
    },
    productCard: {
      borderColor: colors.grey400,
      borderRadius: borderRadius.abs008,
      borderStyle: border.style.solid,
      borderWidth: border.width.s1,
      boxShadow: 'none',
    },
    link: {
      color: colors.grey800,
      textDecoration: 'underline',
    },
    badgeBase: {
      color: colors.viridian1200,
      backgroundColor: colors.viridian200,
      borderRadius: borderRadius.rel333,

      '&.circle': {
        borderRadius: borderRadius.rel333,
      },
    },
    badgePrimary: {
      backgroundColor: colors.viridian200,
      borderRadius: borderRadius.abs008,
      height: dimensions.s24,
      width: dimensions.s24,
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paddingBottom: 0,
      boxSizing: 'border-box',
      overflow: 'inherit',
      lineHeight: 1,
      display: 'flex',

      '&.circle': {
        borderRadius: borderRadius.rel333,
      },
    },
    loadingSpinner: {
      fill: colors.radicalRed1000,
    },
    input: {
      extend: 'inputBaseStyles',
    },
    inputSelectBase: {
      extend: 'inputBaseStyles',
    },
    accordionPanel: {
      borderStyle: border.style.solid,
      borderWidth: border.width.s1,
      borderColor: colors.grey400,
      backgroundColor: colors.grey200,
      padding: dimensions.s16,

      '&.open': {
        borderTolor: `${border.width.s1} ${border.style.solid} ${colors.grey400}`,
      },
    },
    accordionTitle: {
      color: colors.grey800,
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '24px',
    },
  }

  window.hapi.theming.state.theme = {
    ...window.hapi.theming.state.theme.value,
    ...themeOverrides,
  }

  window.hapi.theming.state.fontOptions = {
    fontFaces: [
      {
        fontFamily: 'Inter',
        src: `url(https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuI6fAZ9hjp-Ek-_EeA.woff) format('woff')`,
      },
    ],
    fontFamily: 'Inter',
  }
}
